<template>
  <section-box>
    <template v-if="contact">
      <p class="contact--types">{{ contactTypeText }}</p>
      <h3 class="contact--name" @click="openContactModal">{{ contact.full_name === ' ' ? 'Unknown Contact' :contact.full_name }}</h3>
      <sensitive-data-wrapper>
        <p class="contact--info" v-if="contact.email_address">{{ contact.email_address }}</p>
        <p class="contact--info" v-if="contact.phone_1">{{ contact.phone_1 }}</p>
        <p class="contact--info" v-if="contact.phone_2">{{ contact.phone_2 }}</p>
      </sensitive-data-wrapper>

      <comm-buttons
        class="mt-100"
        :contact="contact"
        :record="record"
        include-button-text
        size="is-small"
      ></comm-buttons>
    </template>
    <p v-else class="empty_message">No primary contact for this lead</p>
  </section-box>
</template>

<script>
import CommButtons from "../../../../../components/comms/CommButtons";
import router from "../../../../../router";
import SensitiveDataWrapper from "../../../../../components/SensitiveDataWrapper.vue";

export default {
  name: "FollowUpContactBox",
  components: {SensitiveDataWrapper, CommButtons},
  props: {
    contact: {
      type: Object,
    },
    record: {
      type: Object,
      required: true
    },
  },
  computed: {
    contactTypeText() {
      if(! this.contact.contactContactTypes) return null;

      let text = "";

      this.contact.contactContactTypes.forEach(type => {
        let allContactTypes = this.$store.state.market.contactTypes;
        const contactType = allContactTypes.find(contactType => contactType.id === type.contact_type_id);

        text += contactType.name + ", ";
      });

      return text.trim().slice(0, -1);
    }
  },
  methods: {
    openContactModal() {
      router.replace({query: {contact: this.contact.id}});
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.contact {

  &--types {
    margin-bottom: 6px;
    color: $text-muted;
    font-size: 0.75rem;
  }

  &--name {
    color: $link;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--info {
    margin-top: 6px;
    font-size: 0.875rem;
  }
}

.empty_message {
  padding: 1rem 0;
  color: $text-light;
  text-align: center;
  font-style: italic;
}
</style>
